import {
  Button,
  CenteredScreen,
  Flex,
  Text,
  WarningVisual
} from '@payflip/ui/v2';
import { useAuth } from '../auth-provider';

export function UnknownAccountPage(): JSX.Element {
  const { auth0User, signOut } = useAuth();

  const email = auth0User?.['https://sso.payflip.be/upn'] ?? auth0User?.email;

  return (
    <CenteredScreen noHeader>
      <Flex
        direction={'column'}
        position={'relative'}
        w={299}
        alignItems="center"
      >
        <WarningVisual />
        <Text
          lineHeight={'36px'}
          fontSize={'24px'}
          fontWeight={'semibold'}
          position="absolute"
          top="152px"
          w="100%"
          textAlign="center"
        >
          Unknown account
        </Text>
      </Flex>
      <Text
        maxW={391}
        size="md"
        fontWeight={400}
        color="palette_gray.60"
        textAlign="center"
      >
        There's no account linked to{' '}
        {email ? <b>{email}</b> : `your email address`} for this application.
      </Text>
      <Text
        maxW={391}
        fontSize="16px"
        lineHeight="24px"
        fontWeight={400}
        color="palette_gray.60"
        textAlign="center"
      >
        Make sure that you're signing in with the same email as the one you
        received your payflip invitation on, or sign in with another method.
      </Text>
      <Button
        onClick={(): void => signOut()}
        variant="primary"
        size="lg"
        mt={8}
        w="100%"
      >
        Go back
      </Button>
    </CenteredScreen>
  );
}
